<template>
  <div :class="{ 'page_content--loading': !reportData }">
    <div v-if="reportData">
      <div class="mt-8">
        <vx-card>
          <data-table
            :row-data="reportData.expectedLandingByPortfolio"
            :column-defs="tableProp.expectedLandingByPortfolio.columnDefs"
            :default-col-def="
              tableProp.expectedLandingByPortfolio.defaultColDef
            "
            :default-sort-model="tableProp.expectedLandingByPortfolio.defaultSortModel"
            pagination
            :current-page="tableProp.expectedLandingByPortfolio.currentPage"
            :pagination-page-size="
              tableProp.expectedLandingByPortfolio.pageSize
            "
            :reset-current-page-flag="resetCurrentPageFlag"
            @update:reset-current-page-flag="resetCurrentPageFlag = false"
          >
            <template #actions>
              <vs-button @click="onClickDownload('expectedLandingByPortfolio')">
                CSVエクスポート
              </vs-button>
            </template>
          </data-table>
        </vx-card>
      </div>
    </div>

    <div class="vx-row justify-end mt-8">
      <div class="vx-col">
        <DateRanges
          :start-day="startDay"
          :end-day="endDay"
          @on-change="onDateChange"
        />
      </div>
    </div>
    <div class="vx-row justify-end">
      <div class="vx-col">
        <switch-field
          v-model="innerFiltered"
          class="mt-4 mb-4"
          name="フィルター表示"
          label="フィルター表示"
        />
      </div>
    </div>
    <div v-if="showFilters" class="vx-row justify-end">
      <div style="z-index: 9998" class="vx-col">
        <div class="filter">
          <sales-filter
            v-model="selectedPortfolioName"
            class="w-48 mb-1 mr-1"
            :options="portfolioNameOptions"
            :no-option-text="costByPortfolioNameFilterNoOptionText"
            placeholder="ポートフォリオ"
          />
          <sales-filter
            v-model="selectedCampaign"
            class="w-48 mb-1 mr-1"
            :options="campaignOptions"
            :no-option-text="costByCampaignFilterNoOptionText"
            placeholder="キャンペーン"
          />
          <sales-filter
            v-model="selectedAdGroupName"
            class="w-48 mb-1 mr-1"
            :options="adGroupNameOptions"
            :no-option-text="costByAdGroupNameFilterNoOptionText"
            placeholder="広告グループ"
          />
        </div>
      </div>
    </div>

    <div
      v-if="reportData.summary.length > 0 || reportData.monthly.length > 0"
      class="vx-row mt-4"
    >
      <div class="vx-col w-1/3 pr-0 flex flex-col">
        <div class="flex flex-row flex-1">
          <score-card
            class="flex-1"
            title="広告経由売上"
            :score="reportData.summary.adSales"
            currency
          />
        </div>
        <div class="mt-4 flex flex-row flex-1">
          <score-card
            class="flex-1"
            title="広告費"
            :score="reportData.summary.adCost"
            currency
          />
          <score-card
            class="flex-1 ml-4"
            title="広告ROAS"
            :score="reportData.summary.adRoas"
            percent
          />
        </div>
      </div>
      <div class="vx-col w-2/3">
        <vx-card>
          <div class="flex justify-end mb-2">
            <vs-button
              @click="onClickDownload('roasChart')"
              class="px-4 pt-2 pb-1"
            >
              <VueFeather type="download" size="1.25rem" />
            </vs-button>
          </div>
          <div>
            <roas-chart
              :class="{ 'min-h-full': !reportData }"
              :report="reportData.monthly"
              :height="400"
              :precision="2"
              label-field="month"
            />
          </div>
        </vx-card>
      </div>
    </div>

    <div
      v-if="reportData.summary.length > 0 || reportData.monthly.length > 0"
      class="vx-row mt-4"
    >
      <div class="vx-col w-1/2">
        <div class="flex">
          <score-card
            class="flex-1"
            title="CV単価"
            :score="reportData.summary.spa"
            currency
          />
          <score-card
            class="flex-1 ml-4"
            title="CPA"
            :score="reportData.summary.cpa"
            currency
          />
        </div>
        <div class="flex mt-4">
          <vx-card>
            <div class="flex justify-end mb-2">
              <vs-button
                @click="onClickDownload('spaCpaChart')"
                class="px-4 pt-2 pb-1"
              >
                <VueFeather type="download" size="1.25rem" />
              </vs-button>
            </div>
            <div>
              <spa-cpa-chart
                :report="reportData.monthly"
                :height="400"
                label-field="month"
              />
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-col w-1/2">
        <div class="flex">
          <score-card
            class="flex-1"
            title="CPC"
            :score="reportData.summary.cpc"
            currency
          />
          <score-card
            class="flex-1 ml-4"
            title="CVR"
            :score="reportData.summary.cvr"
            :precision="1"
            percent
          />
        </div>
        <div class="flex mt-4">
          <vx-card>
            <div class="flex justify-end mb-2">
              <vs-button
                @click="onClickDownload('cpcCvrChart')"
                class="px-4 pt-2 pb-1"
              >
                <VueFeather type="download" size="1.25rem" />
              </vs-button>
            </div>
            <div>
              <cpc-cvr-chart
                :report="reportData.monthly"
                :height="400"
                :precision="2"
                label-field="month"
              />
            </div>
          </vx-card>
        </div>
      </div>
    </div>

    <div v-if="reportData">
      <div class="mt-8">
        <vx-card>
          <data-table
            :row-data="reportData.summaryByPortfolio"
            :column-defs="tableProp.summaryByPortfolio.columnDefs"
            :default-col-def="tableProp.summaryByPortfolio.defaultColDef"
            pagination
            :current-page="tableProp.summaryByPortfolio.currentPage"
            :pagination-page-size="tableProp.summaryByPortfolio.pageSize"
            :reset-current-page-flag="resetCurrentPageFlag"
            @update:reset-current-page-flag="resetCurrentPageFlag = false"
          >
            <template #actions>
              <vs-button @click="onClickDownload('summaryByPortfolio')">
                CSVエクスポート
              </vs-button>
            </template>
          </data-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import ScoreCard from "@/components/ScoreCard";
import DataTable from "@/components/table/DataTable";
import DateRanges from "@/components/DateRanges";
import SalesFilter from "@/components/SalesFilter";
import SwitchField from "@/components/fields/SwitchField";
import CpcCvrChart from "@/user/components/charts/CpcCvrChart";
import SpaCpaChart from "@/user/components/charts/SpaCpaChart";
import RoasChart from "@/user/components/charts/RoasChart";
import { debounce } from "@/utils";

export default {
  components: {
    DataTable,
    DateRanges,
    SalesFilter,
    SwitchField,
    ScoreCard,
    RoasChart,
    CpcCvrChart,
    SpaCpaChart,
  },
  data() {
    return {
      // フィルター
      selectedPortfolioName: [],
      selectedCampaign: [],
      selectedAdGroupName: [],
      filtered: false,
      showFilters: false,
      resetCurrentPageFlag: false,
      // 表のプロパティ
      tableProp: {
        expectedLandingByPortfolio: {
          defaultColDef: {
            sortable: true,
            editable: false,
            resizable: true,
            suppressMenu: true,
          },
          columnDefs: [
            { headerName: "ポートフォリオ", field: "portfolioName", width: 300, pinned: 'left' },
            { headerName: "予算タイプ", field: "policy", width: 110, pinned: 'left' },
            { headerName: "開始日", field: "startDate", width: 130, pinned: 'left' },
            { headerName: "終了日", field: "endDate", width: 130, pinned: 'left' },
            { headerName: "予算", field: "amount", width: 150, currency: true, pinned: 'left' },
            { headerName: "利用金額", field: "totalCost", width: 160, currency: true },
            {
              headerName: "着地見込み",
              field: "expectedLanding",
              width: 160,
              currency: true,
            },
            { headerName: "利用ペース", field: "usagePace", width: 130, percent: true },
            { headerName: "ROAS", field: "roas", width: 160, percent: true },
            { headerName: "CPC", field: "cpc", width: 160, currency: true },
            { headerName: "CVR", field: "cvr", width: 160, percent: true },
            { headerName: "CV単価", field: "spa", width: 160, currency: true },
          ],
          gridOptions: {},
          defaultSortModel: [
            { colId: "totalCost", sort: "desc", sortIndex: 0 },
          ],
          currentPage: 1,
          total: 0,
          pageSize: 50,
        },
        summaryByPortfolio: {
          defaultColDef: {
            sortable: true,
            editable: false,
            resizable: true,
            suppressMenu: true,
          },
          columnDefs: [
            { headerName: "ポートフォリオ", field: "portfolioName", width: 300, pinned: 'left' },
            { headerName: "キャンペーン", field: "campaignName", width: 280, pinned: 'left' },
            { headerName: "広告グループ", field: "adGroupName", width: 280, pinned: 'left' },
            { headerName: "広告経由売上", field: "adSales", currency: true },
            { headerName: "広告費", field: "adCost", currency: true },
            { headerName: "ROAS", field: "roas", percent: true },
            { headerName: "CPC", field: "cpc", currency: true },
            { headerName: "CVR", field: "cvr", percent: true },
            { headerName: "CV単価", field: "spa", currency: true },
            { headerName: "インプレッション数", field: "impressions" },
            { headerName: "クリック数", field: "clicks" },
            { headerName: "コンバージョン数", field: "conversions" },
          ],
          gridOptions: {},
          currentPage: 1,
          total: 0,
          pageSize: 50,
        },
      },
      // APIのactionとパラメータの対応
      apiParameters: {
        expectedLandingByPortfolio: [],
        monthly: ["filters"],
        summary: ["start_day", "end_day", "filters"],
        summaryByPortfolio: ["start_day", "end_day", "filters"],
        costByPortfolioName: ["start_day", "end_day"],
        costByCampaign: ["start_day", "end_day"],
        costByAdGroupName: ["start_day", "end_day"],
        roasChart: ["filters"],
        spaCpaChart: ["filters"],
        cpcCvrChart: ["filters"],
      },
    };
  },
  computed: {
    ...mapState(["startDay", "endDay"]),
    ...mapState("campaignReport", ["requestingStatus", "reportData"]),
    ...mapState("account", ["activeAccount"]),
    costByPortfolioNameFilterNoOptionText() {
      return this.requestingStatus.costByPortfolioName
        ? "Loading..."
        : "候補がありません";
    },
    costByCampaignFilterNoOptionText() {
      return this.requestingStatus.costByCampaign
        ? "Loading..."
        : "候補がありません";
    },
    costByAdGroupNameFilterNoOptionText() {
      return this.requestingStatus.costByAdGroupName
        ? "Loading..."
        : "候補がありません";
    },
    campaignOptions() {
      if (!this.reportData) {
        return [];
      }
      return this.reportData.costByCampaign.map((item) => ({
        text: item.campaign,
        value: item.campaign,
        sales: item.cost,
      }));
    },
    portfolioNameOptions() {
      if (!this.reportData) {
        return [];
      }
      return this.reportData.costByPortfolioName.map((item) => ({
        text: item.portfolioName,
        value: item.portfolioName,
        sales: item.cost,
      }));
    },
    adGroupNameOptions() {
      if (!this.reportData) {
        return [];
      }
      return this.reportData.costByAdGroupName.map((item) => ({
        text: item.adGroupName,
        value: item.adGroupName,
        sales: item.cost,
      }));
    },
    selectedCampaignValues() {
      return this.selectedCampaign.map(
        (selectedCampaign) => selectedCampaign.value
      );
    },
    selectedPortfolioNameValues() {
      return this.selectedPortfolioName.map(
        (selectedPortfolioName) => selectedPortfolioName.value
      );
    },
    selectedAdGroupNameValues() {
      return this.selectedAdGroupName.map(
        (selectedAdGroupName) => selectedAdGroupName.value
      );
    },
    innerFiltered: {
      get() {
        return this.filtered;
      },
      set(val) {
        this.filtered = val;
        this.showFilters = val;
      },
    },
  },
  watch: {
    selectedPortfolioName: {
      handler() {
        this.tableProp.summaryByPortfolio.currentPage = 1;
        this.resetCurrentPageFlag = true;
        this.filterReport();
      },
      deep: true,
    },
    selectedCampaign: {
      handler() {
        this.tableProp.summaryByPortfolio.currentPage = 1;
        this.resetCurrentPageFlag = true;
        this.filterReport();
      },
      deep: true,
    },
    selectedAdGroupName: {
      handler() {
        this.tableProp.summaryByPortfolio.currentPage = 1;
        this.resetCurrentPageFlag = true;
        this.filterReport();
      },
      deep: true,
    },
    activeAccount: {
      handler() {
        this.resetFilters();
      },
    },
  },
  created() {
    // 今月を指定
    this.$store.commit("SET_STARTDAY", moment().startOf("month").format());
    this.$store.commit("SET_ENDDAY", moment().endOf("month").format());
    this.getFilter();
    this.getReport();
  },
  methods: {
    ...mapActions("campaignReport", ["fetchReport", "downloadCSV"]),
    resetFilters() {
      this.selectedPortfolioName = [];
      this.selectedCampaign = [];
    },
    onDateChange(date) {
      this.tableProp.summaryByPortfolio.currentPage = 1;
      this.resetCurrentPageFlag = true;
      this.$store.commit("SET_STARTDAY", moment(date.start).format());
      this.$store.commit("SET_ENDDAY", moment(date.end).format());
      this.getFilter();
      this.filterReport();
    },
    generateParams(paramKeys) {
      const params = {};
      if (paramKeys.includes("start_day") && paramKeys.includes("end_day")) {
        params["start_day"] = this.startDay.split("T")[0];
        params["end_day"] = this.endDay.split("T")[0];
      }
      if (paramKeys.includes("page") && paramKeys.includes("per_page")) {
        params["page"] = this.tableProp.summaryByPortfolio.currentPage;
        params["per_page"] = this.tableProp.summaryByPortfolio.pageSize;
      }
      if (paramKeys.includes("filters")) {
        if (this.selectedPortfolioNameValues) {
          params["portfolio_name"] = this.selectedPortfolioNameValues;
        }
        if (this.selectedCampaignValues) {
          params["campaign"] = this.selectedCampaignValues;
        }
        if (this.selectedAdGroupNameValues) {
          params["ad_group_name"] = this.selectedAdGroupNameValues;
        }
      }
      return params;
    },
    async onClickDownload(action) {
      try {
        await this.downloadCSV({
          ...this.generateParams(this.apiParameters[action]),
          action,
        });
      } catch (e) {
        console.log(e);
      }
    },
    filterReport: debounce(function () {
      // フィルタリングできるレポートだけ再取得
      this.getReport(["monthly", "summary", "summaryByPortfolio"]);
    }, 1000),
    async getReport(
      actions = [
        "expectedLandingByPortfolio",
        "monthly",
        "summary",
        "summaryByPortfolio",
      ]
    ) {
      actions.map(async (action) => {
        try {
          const res = await this.fetchReport({
            ...this.generateParams(this.apiParameters[action]),
            action,
          });
        } catch (e) {
          console.log(e);
        }
      });
    },
    async getFilter() {
      const actions = [
        "costByPortfolioName",
        "costByCampaign",
        "costByAdGroupName",
      ];
      actions.map(async (action) => {
        try {
          this.fetchReport({
            ...this.generateParams(this.apiParameters[action]),
            action,
          });
        } catch (e) {
          console.log(e);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.page_content--loading .vx-card {
  min-height: 127.875px;
}

.text-nowrap {
  text-wrap: nowrap;
}
</style>

<style>
.holamundo :deep(.vs-popup) {
  width: 400px;
}
div.filter {
  display: flex;
  flex-wrap: wrap;
}
.sales-filter .multiselect__tags,
.sales-filter .multiselect__tags .multiselect__input,
.sales-filter .multiselect__content-wrapper {
  font-size: 13px;
}
</style>
